import script from "./FailureCodeView.vue?vue&type=script&setup=true&lang=js"
export * from "./FailureCodeView.vue?vue&type=script&setup=true&lang=js"

import "./FailureCodeView.vue?vue&type=style&index=0&id=488e7e56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-488e7e56"]])

export default __exports__